import util from "../util";

const initialState = { language: util.getCookie('language') || 'en', content: { en: {} }, languages: [] };
const i18n = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_I18N_LANGUAGE':
			return {
				...state,
				language: action.language || 'en'
			};
		case 'SET_I18N_LANGUAGES':
			return {
				...state,
				languages: Array.isArray(action.languages)
					? action.languages
					: Array.isArray(state.languages)
						? state.languages
						: []
			};
		case 'SET_I18N_CONTENT':
			return {
				...state,
				content: action.content
			};
		default:
			return state;
	}
};
export default i18n;